<template>
  <div class="hello" style="background-color:#f4f5f5;">
    <div style="max-width:640px; background: rgb(53, 120, 229);">
        <div style="display:inline-flex; position: relative; width:100%;">
          <div style=" display:inline-flex; margin-left: 15px;">
            <van-icon style="margin-top:5px; margin-right: 5px;" color="#FFFFFF" name="cart-circle-o" size="32px"/>
            <div style="margin-top:7px;">
              <span style="font-weight:600;font-size:20px; color:#FFFFFF">小泉士多</span>
            </div>
          </div>
        </div>
    </div>
    <van-sticky class="item-pop" style="border: 0px;">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto; border: 0px;">
        <div style="height:54px;background: rgb(53, 120, 229); border: 0px;">
            <div style="width:75%;position: absolute; left:0; top: 0;">
              <van-search
                v-model="value"
                shape="round"
                background="rgb(53, 120, 229)"
                placeholder="請輸入搜尋關鍵詞"
                @click="gotosearch()"
              />
            </div>
            <div style=" width:100px;  text-align:right; height:54px; position: absolute; right:8px; top: 0; border:0;">
              <van-badge style=" margin-top:10px;" :content="cartItemNum">
                <div class="child">
                <van-icon name="cart" color="#FFFFFF" size="28" @click="gotocart()"/>
                </div>
              </van-badge>
              <van-icon style="margin-left: 10px;  margin-top:15px;" name="bell" color="#FFFFFF" size="30" />
            </div>
        </div>
      </div>
  </van-sticky>
  <div style="max-width: 640px; background: rgb(53, 120, 229); left:auto; margin: 0 auto;height: 110px; border-radius: 0% 0% 50% 50%; margin-top: -1px;"></div>
    <van-cell-group style="border-radius:20px; margin-top:-100px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:20px; height:150px;" size="large" >
        <van-grid :border="false" style="margin-top:15px;">
          <van-grid-item>
            <van-icon name="logistics" color="#3578e5" size="50px"/>
            <span style="font-weight:900; font-size:14px; color:#3578e5;">宅配免運</span>
            <span style="font-size:6px; color:#77a7ff; margin-top:-10px;">全場免費宅配到府</span>
          </van-grid-item>
          <van-grid-item>
            <van-icon name="paid" color="#3578e5" size="50px"/>
            <span style="font-weight:900; font-size:14px; color:#3578e5;">貨到付款</span>
            <span style="font-size:6px; color:#77a7ff; margin-top:-10px;">全場支持貨到付款</span>
          </van-grid-item>
          <van-grid-item>
            <van-icon name="discount" color="#3578e5" size="50px"/>
            <span style="font-weight:900; font-size:14px; color:#3578e5;">客服減免</span>
            <span style="font-size:6px; color:#77a7ff; margin-top:-10px;">下單聯絡客服減免</span>
          </van-grid-item>
          <van-grid-item>
          <van-icon name="send-gift-o" color="#3578e5" size="50px"/>
            <span style="font-weight:900; font-size:14px; color:#3578e5;">無憂退換</span>
            <span style="font-size:6px; color:#77a7ff; margin-top:-10px;">全場七日無憂鑒賞</span>
          </van-grid-item>
        </van-grid>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:20px; margin-top:20px; margin-left:7px; margin-right:7px;" :border="false">
      <van-cell style="margin-top:5px; border-radius:20px;" :border="false" size="large" >
        <template>
          <span class="Details-title"><van-icon name="fire-o" />好物推介</span>
        </template>
      </van-cell>
      <van-cell  class="recomm-cell"  :border="false" size="large">
        <van-grid :column-num="2" clickable :border="false" >
          <van-grid-item v-for="(item,index) in recomm" :key="index" @click="gotoItem(item.ShortLink)">
            <div style="width:100%; height: 10rem;">
              <van-image width="100%" height="100%" :src="item.banner" fit="fill"/>
            </div>
            <div style="height:40px; display:inline">
              <p style="float:left;  font-size:0.5rem;font-weight:900; line-height: 0.6rem; ">{{ item.ItemTitle }}</p>
            </div>
            <div style="width:100%;height:20px;">
              <span style="float:left; font-size:0.7rem; font-weight:900;color: #3578e5;">{{ item.Currency }}${{ item.Price }}起</span>
              <span style="float:right; font-size:0.7rem;color: gray;">售出：{{ item.sales }}</span>
            </div>
          </van-grid-item>
        </van-grid>
      </van-cell>
    </van-cell-group>
    <div style="margin-top:20px; padding-bottom:50px;">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="用戶須知" name="1">本產品的實際使用效果根據個人情況決定，不保證每位用戶都能享受到所宣傳的效果。若有疑問請通過在線客服聯絡我們，本公司享有最終解釋權。</van-collapse-item>
        <van-collapse-item title="物流配送" name="2">貨物一般在訂單確認的5~10個工作日送達，出現突發狀況可能會有所延遲。貨物送達前都會提前聯絡客戶，請保持電話暢通。</van-collapse-item>
        <van-collapse-item title="退貨流程" name="3">確認收貨—申請退換貨—客服審核通過—用戶寄回商品—倉庫簽收驗貨—退換貨審核—退款/換貨；退換貨請註明：訂單號、姓名、電話。</van-collapse-item>
        <van-collapse-item title="關於我們" name="4">小泉士多致力於為客戶提供優質的商品，並以此爲目標不斷努力。爲了保障您的權益，購物前請認準我們的官方網站和社交媒體。</van-collapse-item>
        <van-collapse-item title="聯絡我們" name="5">如果您有問題需要幫助，可以通過在線客服與我們聯絡，或前往我們的Facebook主頁。客服電郵：support@koizumishop.com</van-collapse-item>
      </van-collapse>
    </div>
    <div style="margin:0 auto; text-align:center; padding-bottom:80px;">
      <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
      <div style="margin-top:20px;">
        <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getItemRecommend } from '@/api/item'
import { Toast } from 'vant'
import cart from '@/utils/cart'
// import { addOrder, getOrder } from '@/api/order'
// import { Notify, Toast } from 'vant'
// import axios from 'axios'
export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      current: 0,
      show: false,
      recomm: [],
      activeNames: [],
      active: 0,
      value: '',
      cartItemNum: cart.cartItemNum
    }
  },
  created () {
    this.getRecommendInfo()
    console.log()
  },
  mounted () {
    setTimeout(() => {
      this.sharkFlag = true
    }, 5000)
  },
  methods: {
    initPixel () {
      window.fbq('init', '519571556714129')
      window.fbq('track', 'PageView')
      window.fbq('track', 'ViewContent')
    },
    getRecommendInfo () {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      getItemRecommend({ code: '', nums: 12 }).then(res => {
        if (res.code === 200) {
          this.recomm = []
          this.recomm = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    },
    gotosearch () {
      window.scrollTo(0, 0)
      this.$router.push('/search')
    },
    gotocart () {
      this.$router.push('/cart')
      window.scrollTo(0, 0)
    },
    gotoItem (link) {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
      this.$router.push('/' + link)
      window.scrollTo(0, 0)
    },
    openchat () {
    },
    gotoorder () {
      this.$router.push('/order')
      window.scrollTo(0, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .Details-title {
    width: 100%;
    font-weight: 900;
    font-size: 14px;
  }
  .recomm-cell{
  border-radius:20px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  }
  .recomm-cell .van-grid >>>.van-grid-item__content {
  padding-top: 2px !important;
  padding-left: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue